import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { AboutSection } from '../components/AboutSection';
import { MethodSection } from '../components/MethodSection';
import { ServicesSection } from '../components/ServicesSection';
import { ResourcesSection } from '../components/ResourcesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FooterCTA } from '../components/FooterCTA';
import { GDPRSection } from '../components/GDPRSection';
export function HomePage() {
  return <main className="min-h-screen w-full font-sans text-body bg-white overflow-x-hidden" data-id="element-248">
      <Navbar data-id="element-249" />
      <div className="h-16" data-id="element-250"></div>
      <HeroSection data-id="element-251" />
      <PainPointsSection data-id="element-252" />
      <AboutSection data-id="element-253" />
      <MethodSection data-id="element-254" />
      <ServicesSection data-id="element-255" />
      <ResourcesSection data-id="element-256" />
      <TestimonialsSection data-id="element-257" />
      <FooterCTA data-id="element-258" />
      <GDPRSection data-id="element-259" />
    </main>;
}